import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OcrResult } from 'app/core/models/ocr_result.model';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';
import { PatientAttachmentsService } from 'app/core/services/patient-attachments.service';

@Component({
  selector: 'app-ocr-result-text',
  templateUrl: './ocr-result-text.component.html',
  styleUrls: ['./ocr-result-text.component.scss'],
  imports: [MatProgressSpinnerModule]
})
export class OcrResultTextComponent implements OnChanges {
  private patientAttachmentsService = inject(PatientAttachmentsService);

  @Input() patientAttachment: PatientAttachment;
  @Input() loadOnDemand = false;
  ocrResult: OcrResult;
  loading = false;

  hintText = (window.navigator && window.navigator.platform.indexOf('Mac') >= 0) ?
    '(Click text and type cmd+f to search)' :
    '(Click text and type ctrl+f to search)';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patientAttachment']) {
      if (this.patientAttachment?.ocrResult) {
        this.ocrResult = this.patientAttachment.ocrResult;
        this.loading = false;
      } else if (this.loadOnDemand && this.patientAttachment?.standardConsultNote) {
        this.loadOcrResult();
      } else {
        this.ocrResult = null;
        this.loading = false;
      }
    }
  }

  private loadOcrResult() {
    this.loading = true;
    this.patientAttachmentsService.getOcrResult(this.patientAttachment.id).subscribe({
      next: ocrResult => {
        this.ocrResult = ocrResult;
        this.loading = false;
      },
      error: () => {
        this.ocrResult = null;
        this.loading = false;
      }
    })
  }
}
